import { ViewModel, ObservableArray, View } from "binder";
import { Enum } from "../../../enum";
import { getAsBoolean } from "../../../utilities";
import { ColumnFilter } from "../columnFilter";
import  { EnumFilterView } from "./enumFilter-view"

export class EnumFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.enumValues = ObservableArray.create<enumValue>();
    }
    GetDefaultView(): View <ViewModel> {
        return new EnumFilterView();
    }
    public getTypeId(): string {
        return "VM-1840F920-D43B-4CE9-9C60-38CA9024FD62"
    }

    public set enumProvider(v: Enum) { 
        this._enumProvider = v; 
        this.enumValues.update(...v.getValuesWithTheirStringValues().map(x=>{
            let r = new enumValue(this);
            r.stringValue = x.stringValue;
            r.value = x.value;
            return r;
        }))
    } public get enumProvider(): Enum { return this._enumProvider;} private _enumProvider: Enum;

    public set enumValues(v: ObservableArray<enumValue>) { this._enumValues = v; } public get enumValues(): ObservableArray<enumValue> { return this._enumValues;} private _enumValues: ObservableArray<enumValue>;
}

export class enumValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ViewModel) {
        super(parent);
        this.isSelected = false;        
    }
    
    public set value(v: any) { this._value = v; } public get value(): any { return this._value;} private _value: any;
    public set stringValue(v: string) { this._stringValue = v; } public get stringValue(): string { return this._stringValue;} private _stringValue: string;
    public set isSelected(v: boolean) { 
        this._isSelected = v; 
    } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
}

